import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Input, message, Spin, Drawer, ConfigProvider, Modal } from 'antd';
import React, { useState } from 'react';
import { post } from '../../../../../axios/axios';
import closeIcon from '../../images/icon_close.svg';
import { converterInstance } from '../../components/AcademicEditor/MarkdownConverter';
import './tableModal.scss';

// 重写章节
const RewriteModal = NiceModal.create(({ orderNo, content, from, to, chapterId }) => {
    const modal = useModal();
    const [prompt, setPrompt] = useState('');
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [generatedContent, setGeneratedContent] = useState('');

    const handleOk = async () => {
        if (!generatedContent) {
            message.warning('请先生成内容');
            return;
        }
        try {
            modal.resolve(generatedContent);
            modal.hide();
        } catch (error) {
            message.error('替换失败，请重试');
            console.error('error', error);
        }
    };

    const fetchData = async () => {
        if (!orderNo || !chapterId) {
            message.error('缺少必要参数，请重试');
            return;
        }
        if (!prompt) {
            message.warning('请输入提示词');
            return;
        }

        try {
            // const htmlContent = converterInstance.makeHtml(
            //     '[AIML_TEXT]高等院校宿舍管理身为校园后勤保障的关键构成部分，其效率与质量直接关乎学生的生活感受和学习状况。伴随高等教育规模持续拓展，寝室管理所面临的问题愈发显著。 。传统管理模式大多依靠人工操作，信息记载零散且易生差错，引发资源分配不均衡、维修响应迟缓等问题频繁出现[AIML_SUPERSCRIPT][1][/AIML_SUPERSCRIPT]。特别是在高峰时段，例如新生入学或者毕业离校期间，寝室分配的压力进一步加大了管理难度[AIML_SUPERSCRIPT][2][/AIML_SUPERSCRIPT]。除此之外，学生对于宿舍环境与服务的需求渐趋多样化。，当前的管理方法难以契合这些个性化需求。 ，致使矛盾更为突显。在信息化高速发展的背景下，高等院校宿舍管理迫切需要向数字化转变。然而，诸多学校依旧运用纸质表格或者简易的电子表格开展数据管理工作。 ，此种方式不仅效率欠佳，还易因人为疏忽导致信息缺失或差错。譬如，于宿舍分配环节中，时常出现床位重复分配或闲置浪费的状况[AIML_SUPERSCRIPT][3][/AIML_SUPERSCRIPT]。同时，宿舍设施的维护亦缺少体系化的跟踪机制。，报修程序繁杂，且反馈时长较长。 ，对学生的居住体验造成了影响。这些难题显示出，传统管理模式难以契合现代高校宿舍管理的实际要求。 。近年间，信息科技的推广为宿舍管理供给了新的解决办法。借助引入智能化管理体系，能够达成宿舍资源的动态监测与高效分配。。此类系统不仅可实时更新宿舍使用状况，还可依据历史数据的分析来预估未来的资源需求，进而优化决策流程[AIML_SUPERSCRIPT][4][/AIML_SUPERSCRIPT]。譬如，部分高校已着手尝试依托物联网技术的宿舍管理系统。，用于监控水电消耗、安全防护状况等关键指标，收获了显著成效[AIML_SUPERSCRIPT][5][/AIML_SUPERSCRIPT]。即便如此，当前，多数高校仍未全面推行此类系统。，主要缘由在于资金投入欠缺和技术支撑匮乏。 。从长远视角而言，搭建一套完备的宿舍管理系统不仅是提高管理效率的要点，亦是提升学生生活品质的关键方式。它有助于管理者更精确地把握宿舍资源的使用状况，削减非必要的浪费，同时提升学生的参与度，使他们在住宿事宜中享有更多自主权。。譬如，经由在线平台递交维修申请或调整宿舍偏好，能够使学生体会到服务的便利性与透明度[AIML_SUPERSCRIPT][6][/AIML_SUPERSCRIPT]。此双向互动模式有益于减轻管理方和学生之间的沟通阻碍。 ，推动校园和谐进步。寝室管理系统的开发与运用已成为高等院校后勤革新的关键方向之一。应对当下存在的诸多问题，运用先进的技术方法构建智能化、精准化的管理模式，将为高校宿舍管理增添新的动力，并为其可持续发展筑牢坚实根基。[/AIML_TEXT]',
            // );
            // setGeneratedContent(htmlContent);
            // console.log('htmlContent', htmlContent);

            setLoading(true);
            const res = await post('/ai/ai/paper/editor/rewriteChapter', {
                orderNo,
                chapterId,
                prompt,
            });

            if (res.data) {
                // 使用 converterInstance 转换返回的内容
                const htmlContent = converterInstance.makeHtml(res.data);
                setGeneratedContent(htmlContent);
            } else {
                throw new Error('返回数据为空');
            }
        } catch (error) {
            message.error('生成失败，请重试');
            console.error('error', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ConfigProvider
                theme={{
                    token: {
                        colorBgMask: 'rgba(0, 0, 0, 0.01)',
                    },
                }}
            >
                <Drawer
                    title="重写章节"
                    placement="right"
                    mask={true}
                    maskClosable={true}
                    open={modal.visible}
                    closeIcon={null}
                    destroyOnClose={true}
                    headerStyle={{ borderBottom: 'none' }}
                    bodyStyle={{ padding: '0 24px' }}
                    onClose={() => setShowConfirm(true)}
                    extra={
                        <img
                            className="block h-4 w-4 cursor-pointer"
                            src={closeIcon}
                            onClick={() => setShowConfirm(true)}
                            alt=""
                        />
                    }
                >
                    <div style={{ width: '552px' }}>
                        <div className="flex flex-col gap-4">
                            {/* 提示词输入 */}
                            <div>
                                <div className="title mb-2" style={{ color: '#192038' }}>
                                    提示词
                                </div>
                                <Input.TextArea
                                    className="h-[114px] w-full rounded-md p-3"
                                    style={{
                                        background: '#ffffff',
                                        border: '1px solid #E9E9EA',
                                    }}
                                    placeholder="请尽量详细描述您想要的内容"
                                    value={prompt}
                                    onChange={(e) => {
                                        setPrompt(e.target.value);
                                    }}
                                />
                            </div>

                            {/* 生成按钮 */}
                            {!generatedContent && (
                                <Button
                                    type="primary"
                                    onClick={fetchData}
                                    loading={loading}
                                    className="w-full"
                                >
                                    生成内容
                                </Button>
                            )}

                            {/* 生成结果 */}
                            {loading ? (
                                <div className="flex h-32 items-center justify-center">
                                    <Spin />
                                </div>
                            ) : generatedContent ? (
                                <div>
                                    <div className="title mb-2" style={{ color: '#192038' }}>
                                        生成结果
                                    </div>
                                    <div
                                        className="w-full rounded-md p-3"
                                        style={{
                                            background: '#ffffff',
                                            border: '1px solid #9557FF',
                                        }}
                                    >
                                        <div
                                            className="content academic-content mt-4 max-h-[400px] overflow-y-auto text-sm"
                                            style={{ lineHeight: '22px' }}
                                            dangerouslySetInnerHTML={{ __html: generatedContent }}
                                        />
                                    </div>
                                </div>
                            ) : null}

                            {/* 底部按钮 */}
                            {generatedContent && (
                                <div className="btns mt-8 flex items-center justify-center">
                                    <Button type="primary" onClick={handleOk}>
                                        替换原文
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        onClick={fetchData}
                                        style={{ background: '#F8FBFF' }}
                                    >
                                        重新生成
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </Drawer>
            </ConfigProvider>

            {/* 关闭确认弹窗 */}
            <Modal
                zIndex={100000}
                title="确认关闭"
                destroyOnClose={true}
                open={showConfirm}
                onOk={() => {
                    setShowConfirm(false);
                    modal.reject();
                    modal.hide();
                }}
                onCancel={() => setShowConfirm(false)}
                okText="确认"
                cancelText="取消"
            >
                <p>确定要关闭当前窗口吗？</p>
            </Modal>
        </>
    );
});

export default RewriteModal;
